import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import imgAssistant from "../../../assets/images/landing/assistant/img-2.png";
import dashboardImg from "../../../assets/images/landing/assistant/dashboard1.jpg";
import contadorImg from "../../../assets/images/landing/assistant/contador4.jpg";
import rrhhImg from "../../../assets/images/landing/assistant/rrhh3.jpg";
import admImg from "../../../assets/images/landing/assistant/adm2.jpg";

import "swiper/css";
import "swiper/css/pagination";
import "./scss/assistant.scss";

const Assistant = () => {
  return (
    <section className="assistant-section">
      <Container>
        <Row className="align-items-center gy-4">
          <Col lg={6} className="order-2 order-lg-1">
            <div className="assistant-text">
              <h5 className="section-subtitle">IAssistant</h5>
              <h4 className="section-title">
                IAssistant by BackApp - Plataforma de asistencia al cliente
              </h4>
              <p className="section-description">
                Potenciamos y transformamos la forma en que ves cada proceso de
                la administración de tu empresa con nuestra plataforma IAssistant
                siempre con el apoyo de nuestros multiservicios.
              </p>

              <Swiper
                modules={[Autoplay, Pagination]}
                slidesPerView={1}
                loop={true}
                autoplay={{ delay: 1500, disableOnInteraction: false }}
                pagination={{
                  clickable: true,
                  dynamicBullets: false,
                }}
                className="assistant-carousel"
              >
                <SwiperSlide>
                  <div className="assistant-card">
                    <h5>Dashboard</h5>
                    <img src={dashboardImg} alt="Dashboard" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="assistant-card">
                    <h5>Contabilidad</h5>
                    <img src={contadorImg} alt="Contabilidad" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="assistant-card">
                    <h5>Recursos Humanos</h5>
                    <img src={rrhhImg} alt="RRHH" />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="assistant-card">
                    <h5>Administración</h5>
                    <img src={admImg} alt="Administración" />
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="mt-4">
                <Link to="#" className="btn-aesthetic">
                  ¡Prueba hoy mismo IAssistant by BackAppChile!
                  <i className="ri-arrow-right-line align-middle ms-1"></i>
                </Link>
              </div>
            </div>
          </Col>

          <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-2">
            <img src={imgAssistant} alt="IAssistant" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Assistant;